import React from "react";

import styles from "./image-flex.module.scss";

export const ImageFlex: React.FC = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);
